import styled from "styled-components";

const Parent = styled.div`
  display: flex;
  fled-direction: row;
  width: 100vw;
  height: 100vh;
`;

export default Parent;



// WEBPACK FOOTER //
// ./src/components/Parent.js